import {
	IonBackButton,
	IonButtons,
	IonHeader,
	IonPage,
	IonSkeletonText,
	IonTitle,
	IonToolbar,
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import { type MarkRequired } from "ts-essentials";
import { Content } from "@/components/Global/Content";
import { Toolbar } from "@/components/Global/Toolbar";
import { ReflectionChatSummary } from "@/components/Reflection/ChatSummary";
import { useReflection } from "@/lib/hooks/useReflection";
import { arrowLeftIcon } from "@/lib/icons/@heroicons/react/20/solid";
import { Routes } from "@/lib/router";

export function ReflectionDetails() {
	const { t } = useTranslation();
	const { isLoading, data: reflections } = useReflection();

	return (
		<IonPage>
			<IonHeader>
				<Toolbar className="ion-p-2 plt-desktop:sm:ion-px-[max(calc(calc(100vw-640px)/2),--spacing(4))]">
					<IonTitle className="ion-text-brown-700 text-lg font-bold">
						{t("reflection.name")}
					</IonTitle>

					<IonButtons slot="start">
						<IonBackButton
							data-attr="page.reflection.details.back"
							data-touch-target
							defaultHref={Routes.Dashboard()}
							color="light"
							className="part-icon:m-0 part-icon:size-5 part-native:size-10 part-native:min-h-0 part-native:rounded-full part-native:bg-brown-300 part-native:p-1 part-native:text-xs part-native:text-brown-600 min-h-0"
							icon={arrowLeftIcon}
							text=""
						/>
					</IonButtons>
				</Toolbar>
			</IonHeader>

			<Content className="part-scroll:gap-4">
				<IonHeader collapse="condense" className="-mt-(--padding-top)">
					<IonToolbar className="ion-px-0">
						<IonTitle className="ion-text-brown-700 p-0 text-start text-3xl font-bold">
							{t("reflection.name")}
						</IonTitle>
					</IonToolbar>
				</IonHeader>

				<div className="flex flex-col gap-4">
					{isLoading ? (
						<IonSkeletonText animated className="m-0 h-42 rounded-2xl px-4 py-3" />
					) : (
						reflections
							?.filter(
								(reflection): reflection is MarkRequired<typeof reflection, "reflectionChat"> =>
									reflection.reflectionChat?.status === "FINISHED",
							)
							.toSorted((a, b) => {
								const aDate = new Date(a.reflectionChat.createdAt);
								const bDate = new Date(b.reflectionChat.createdAt);
								return aDate.getTime() - bDate.getTime();
							})
							.map((reflection) => (
								<ReflectionChatSummary key={reflection.id} data={reflection.reflectionChat} />
							))
					)}
				</div>
			</Content>
		</IonPage>
	);
}
